var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m13.132 11.66-1.729-1.812-3.129-3.284a.9.9 0 0 1-.232-.924.83.83 0 0 1 .657-.62c.31-.066.573.038.795.27q1.1 1.152 2.2 2.305l3.19 3.351c.422.444.423.962 0 1.406q-2.688 2.823-5.38 5.645c-.496.52-1.282.331-1.467-.352a.9.9 0 0 1 .227-.898l4.721-4.952c.042-.044.089-.082.147-.134",
  clipRule: "evenodd"
})));
export default SvgChevronRight;